import ExploreRecipe from "../components/Recipes/ExploreRecipe";

const ExploreRecipePage = (): JSX.Element => {
  return <ExploreRecipe />;
};

export default ExploreRecipePage;
